"use client"
import { X, MapPin } from "lucide-react"

const SeatAssignmentModal = ({ isOpen, onClose, seatNumber, setSeatNumber, isEditing, onAssign }) => {
  const handleSubmit = async (e) => {
    e.preventDefault()
    // Get the current seat number from the input
    const currentSeatNumber = e.target.seatNumber?.value || seatNumber
    if (!currentSeatNumber) {
      // console.error('Seat number is required')
      return
    }

    try {
      // Call onAssign with the required parameters
      await onAssign(currentSeatNumber)
      onClose()
      setSeatNumber("")
    } catch (error) {
      // console.error('Error in seat assignment:', error)
      // The error will be handled by the parent component
    }
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-green-100 rounded-lg">
              <MapPin className="text-green-600" size={20} />
            </div>
            <h3 className="text-xl font-semibold text-gray-900">
              {isEditing ? "Edit Seat Assignment" : "Assign Seat"}
            </h3>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors duration-150">
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label htmlFor="seatNumber" className="block text-sm font-medium text-gray-700 mb-2">Seat Number</label>
            <input
              id="seatNumber"
              name="seatNumber"
              type="text"
              value={seatNumber}
              onChange={(e) => setSeatNumber(e.target.value)}
              placeholder="Enter seat number (e.g., A1, B12, VIP-5)"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
              required
            />
            <p className="text-xs text-gray-500 mt-1">Enter any seat identifier that makes sense for your event</p>
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 font-medium rounded-lg transition-colors duration-150"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-3 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-colors duration-150"
            >
              {isEditing ? "Update Seat" : "Assign Seat"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default SeatAssignmentModal
